import React, { FC, useRef, useContext, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, BrowserRouter, useLocation } from "react-router-dom";
import { injectIntl } from "react-intl";
import { Stack, Text } from "@fluentui/react";
import { classNamesFunction } from "@fluentui/react/lib/Utilities";
import axios from "axios";
import ".././commonStyle.css";
import type {
  MessageData
} from "../../../../app/components/Chat/data";
import {
  IApplicationContext,
  ServiceContext,
  ExtensionsRegistrationClient,
  ApplicationContext,
  IUser,
} from "@msx/platform-services";
import {
  getExtensionsLoadingStatus,
  getExtensionsRegistration,
  getCurrentLocale,
  setCurrentLocale,
  getCurrentTheme,
  getCurrentAppState,
  getSelectedCategories,
  SetIsWwicCopilot,
  SetIsConversationId,
  SetInitialzeApp,
  getIsWwicCopilot,
  SETChileComponentName,
  SETHasServiceRequestTypeLogData,
  SETLogEventData,
  SETServiceRequestTypeLogData,
  SETIsCustomeLog
} from "../../../store";

import {
  getUserProfileLoadingStatus,
  getUserDashboardTiles,
} from "../../../../app/store";

import { BusyIndicator } from "../../";
import { ShellHeader, ShellHeaderV2Demo } from "./components/ShellHeader";
import { ShellRoutes, ShellRoutesV2Demo } from "./components/ShellRoutes";
import { AppFooter } from "../../../../app/components";
import { appConfig } from "../../../../app/App.config";
import { getStyles } from ".././Shell.styles";
import { messages } from ".././Shell.messages";
import { getEnvVarUtils } from "../../../utils";
import { Signin } from "../../../../app/pages";
import { DataServiceContext } from "../../../../app/context";
import "react-toastify/dist/ReactToastify.css";
import {
  getHeaderTokenFunc,
  getConsumptionAPI,
  callMultipleAPIsSettled,
  // getConsumptionAPILocal,
  // postConsumptionAPILocal
} from "../../../../app/utils/httpUtils";
import {
  getGraphTransitiveMemberOf,
  getGraphTransitiveMemberOfAi,
} from "../../../../app/pages/Authorize/AuthorizeUtility";
import apiService from "../../../../errorHandling/appService";
import { setTimeout } from "timers";
import EventLoggingProviderFC from "../../../../errorHandling/EventLoggingProviderFC";
import { GetTheTileConfiguration } from "../../../../app/components/TileConfiguration/V2_TileConfigurationHelperFile";
import Loader from "../../../components/shell/Loader";
import FeedbackTabComponent from "../../../../app/components/feedback/FeedbackTabComponent";
import { FooterMain } from "../../../../app/components/footer/FooterMain";
import { getFormNames } from "../../../../app/components/TileConfiguration/V2_APIHelperFile";
import { Route } from "react-router";
import { Chat } from "../../../../app/components/Chat/Chat";
import ShimmerLoader from "../../../../app/components/main/Services/ShimmerLoader";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import {
  NOT_AI_Authorised,
  NOT_AI_AUTHORISED_TWO,
  SERVICE_LOCKED,
} from "../../../../app/utils/constants";
import { V2_WhatsNew } from "../../../../app/components/Announcements/V2_Components/V2_Announcements";

import { fetchAllFiltersOptions } from "../../../../app/components/CatalogPage/V2component_catalog/V2_CatalogPage";
import V2_Prompt from "../../Prompts/V2component_Prompt/V2_Prompt";
import { V2_ShellProps } from "./V2_Shell_types";
import { useSessionTokens, useAnnouncements, useUserAuthorization, useUserProfile } from "./hooks";
import NewUI_Shell from "../NewUI/NewUI_Shell";
import { setTicketDetailsData } from "../../../store/actions/app.actions";
import { getExternalConsumptionAPI } from "../../../../app/utils/httpUtilsExternalAPI";
import { isFeatureEnabled } from "../../../../app/services/FeatureFlagService";

const getClassNames = classNamesFunction<any, any>();
let classes: any;
const defaultUser: IUser = {
  id: "",
  name: "",
  email: "",
};

const V2_ShellComponent: FC<V2_ShellProps> = (props) => {
  const { intl } = props;
  const reduxDispatch = useDispatch();
  const location = useLocation();
  const currentAppState = useSelector(getCurrentAppState);
  const SelectedCategoriesData = useSelector(getSelectedCategories);
  const currentTheme = useSelector(getCurrentTheme);
  const userDashboardTiles = useSelector(getUserDashboardTiles);
  const userProfileLoadingStatus = useSelector(getUserProfileLoadingStatus);
  const extensionsLoadingStatus = useSelector(getExtensionsLoadingStatus);
  const [showFabricComponent, setShowFabricComponent] = useState(false);
  const extensionsRegistration = useSelector(getExtensionsRegistration);
  const isWwicCopilotOpen = useSelector(getIsWwicCopilot);
  const [activeTicketCount, setActiveTicketCount] = useState(0);
  const [refreshHeaderTabCount, setRefreshHeaderTabCount] = useState<boolean>(false);
  const extensionsRegistrationClient = new ExtensionsRegistrationClient(
    extensionsRegistration
  );
  const currentLocale = useSelector(getCurrentLocale);
  const currentLocaleRef = useRef(currentLocale);
  const { authClient } = useContext(ServiceContext);
  const [isNavCollapsed] = useState(false);
  const [currentUser, setCurentUser] = useState(defaultUser);
  const { dataService } = useContext(DataServiceContext);
  const [showBotinShell, setshowBotinShell] = useState(true);
  const [currentUserDbId, setCurrentUserDbId] = useState(0);

  const context = React.useContext(ServiceContext);
  const [addServiceId, setAddServiceId] = useState(0);
  //setting the first pivot tab  as default
  const [selectedActiveTab, setselectedActiveTab] = useState("0");
  const [iriS_Utterance, setIris_Utterance] = useState("");
  const [tileName, setTile_Name] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [irisBotIconClicked, setIrisBotIconClicked] = React.useState(false);
  const [irisAppName, set_irisAppName] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  //catalog page related states
  const [servicesAdded, setServicesAdded] = useState(false);
  const [catalogServicesResponse, setCatalogServicesResponse] = useState(null);
  const [ticketDataLoaded, setTicketDataLoaded] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [serviceDeleted, setServiceDeleted] = useState(false);
  const [singleServiceAdded, setSingleServiceAdded] = useState(false);


  const [currentUserIsWelcomeMessage, setCurrentUserIsWelcomeMessage] =
    useState(null);
  const [isCheckedMessage] = useState(false);
  const [chatBotClicked, setChatBotClicked] = useState(false);
  const [formDataToIris, setFormDataToIris] = useState(null);

  const [messageHistory, setMessageHistory] = React.useState<MessageData[]>([]);

  const [triggerErrorMessage, setTriggerErrorMessage] = useState<boolean>(false);
  //Multipage Welcome exp
  const theme = useSelector(getCurrentTheme);
  classes = getClassNames(getStyles, theme);
  const [openedThroughMenu] = useState(false);
  const [finalTileObject, setFinalTileObject] = useState({
    isIncidentTile: false,
    isNonAmerica: false,
    isAmerica: false,
    isAmericaSMC: false,
    isValidated: false,
    isFeedbackUrlDownload: false,
    isLoaded: false,
    TileName: "",
    IrisUtterance: "",
    Area: "",
    Segment: "",
    SubSegment: "",
    Mode: "",
    downloadfile: "",
    typeOfFeedback: "",
    Error: "",
    loadForms: false,
    tileinfo: false,
    sendServiceGroup: false,
    defaultServiceGroup: "",
    appname: "",
    prompt: "",
  });
  const [showErrorModal, setShowErrorModal] = useState({
    isErrorModalVisible: false,
    errorMessage: "",
  });
  const [loadedVisibility, setLoadedVisibility] = useState(false);
  const [openTheSegmentPopUp, setTheSegmentPopUp] = useState(false);
  classes = getClassNames(getStyles, currentTheme);
  const apiEndPoint = `${process.env.REACT_APP_Consumption_API_ENDPOINT}`;
  const apiEndPointLocal = `https://localhost:44348`;
  // Use REACT_APP_WEBLOCALSTORAGE_KEY from .env (pipeline will replace the version during build)
  const WEBFORMNAMES_LOCAL_STORAGE_KEY = process.env.REACT_APP_WEBLOCALSTORAGE_KEY || "v2_webFormNames_1.0.0";

  // --- Error handlers (moved up for hook parameter access) ---
  const handleNotFoundResponse = () => {
    setIsOpen(true);
    // Reset userId to 0 to prevent stale authenticated UI/API flow when a prior user id was already loaded
    setCurrentUserDbId(0);
    setCurrentUserIsWelcomeMessage(false);
  };

  const handleErrorResponse = (error) => {
    if (error.response) {
      if (error.response.status === 204) {
        handleNotFoundResponse();
      } else if (error.response.status === 404) {
        handleNotFoundResponse();
      } else if (error.response.status === 401) {
        alert(
          "Oops! There seems to be an issue with the token. Please try refreshing the page or logging in again to resolve the issue."
        );
      }
    } else {
      console.error("An error occurred while fetching data.", error);
    }
  };

  // --- Extracted hooks (Phase 1 PR #1 + PR #2) ---
  const {
    isSasLoaded, setSasLoaded, isSasCalled, setSasCalled,
    envVariableCalled, setEnvVarCalled, envVariableLoaded, setEnvVarLoaded,
    getAccessTokenForAPICall, setAccessTokenForAPIcall,
    getIrisToken, getStorageSasToken, getEnvVariables,
  } = useSessionTokens(handleErrorResponse);

  const {
    announcementJsondataa, setAnnouncementJsondataa,
    filteredAnnouncementss, setfilteredAnnouncementss,
    hideDialog, setHideDialog,
    SetAnnouncmentData, filterAndSort, toggleHideDialog,
    dismissedAnnouncements,
  } = useAnnouncements();

  // --- Extracted hooks (Phase 1 PR #3 + PR #4) ---
  const {
    isStartupError, startupError,
    isUserLoggedIn,
    isUserAuthorized, setUserAuthorized,
    isUserAuthorizedAi, setUserAuthorizedAi,
  } = useUserAuthorization({ setCurentUser });

  const isUserLoggedInRef = useRef(isUserLoggedIn);

  const {
    currentUserData, userDataCreated,
    isPageLoad, setIsPageLoad,
    userDataChanged,
    isDefaultPrefSet, isPresetModal,
    isProfileLoading, setProfileLoading,
    isAmericasPref, isAmericasSMCPref,
    isParamerterLoad, setParamerterLoad,
    isCanceledPreset,
    reccomendedData, recommendationLoaded, setRecommendationLoaded,
    isAiUser, isAiServicesEnabled, isAreaSupportEnabled, isWwicAiEnabled,
    isMCAPSCopilotEnabled, setIsMCAPSCopilotEnabled,
    Area, RoleSummary, OrgSummary, OrgDetail,
    Segment, setSegment, SubSegment, setSubSegment,
    prefrenceRefresh, setPrefrenceRefresh,
    userWelcomeUpdated, setUserWelcomeUpdated,
    userEmailCalled, setUserEmailCalled,
    getUserIDByEmailId, validateUserIDByEmailId,
    getDefaultAmericasPref,
    createUser, handleChildStateChange,
    handleConfirmPreset, hideConfirmModel,
    updateUser,
  } = useUserProfile({
    getAccessTokenForAPICall, setAccessTokenForAPIcall,
    isUserLoggedIn,
    currentUser,
    currentUserDbId, setCurrentUserDbId,
    currentUserIsWelcomeMessage, setCurrentUserIsWelcomeMessage,
    finalTileObject, setFinalTileObject,
    handleErrorResponse, handleNotFoundResponse,
    setIsOpen, setTheSegmentPopUp,
  });

  const [isIrisLoader, setIsIrisLoader] = useState(false);
  const [isPrompt, setIsPrompt] = useState(false);
  const [isCopilot, setIsCopilot] = useState(false);
  const [loadingPrompt, setLoadingPrompt] = useState(true);
  const [Arr, setArr] = useState(false);
  const [Category, setCategory] = useState<any>();
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const hasFetchedData = useRef(false);
  const latestRequestId = useRef(0);
  const hasCheckedEarlyAdopter = useRef(false);

  // Listen for copilot access map resolved by V2_Tile (replaces per-user isMCAPSCopilotEnabled flag)
  useEffect(() => {
    const onMapReady = () => {
      setIsMCAPSCopilotEnabled(sessionStorage.getItem('hasCopilotAccess') === 'true');
    };
    window.addEventListener('copilotAccessMapReady', onMapReady);
    return () => window.removeEventListener('copilotAccessMapReady', onMapReady);
  }, []);

  setTimeout(() => {
    const button = document.querySelector(
      'button[title="Start Over"]'
    ) as HTMLButtonElement;
    if (button) {
      button.addEventListener("click", handleChatBotIconClick);
    }
  }, 3000);

  //3. UseEffect
  useEffect(() => {
    if (isUserLoggedIn) {
      getConfig();
      getDefaultAmericasPref("Get").then(() => {
        getForm();
        setLoadedVisibility(true);
      });
    }
    // eslint-disable-next-line
  }, [isUserLoggedIn]);

  //6.effect
  useEffect(() => {
    if (currentUserDbId > 0) {
      fetchDataAndUpdateState();
    }
  }, [SelectedCategoriesData]);

  //7.effect
  useEffect(() => {
    if (currentUserDbId > 0) {
      fetchCatalogTileCount();
      if (!hasFetchedData.current) {
        fetchDataAndUpdateState();
      }
      isPrompt && getPrompts();
      setServiceDeleted(false);
      setSingleServiceAdded(false);
      RequestAccessValidatorFunc();
      RequestAccessValidatorForAi();
      singleServiceAdded && setRefreshHeaderTabCount(!refreshHeaderTabCount);
    }
  }, [
    context,
    servicesAdded,
    currentUserData,
    serviceDeleted,
    singleServiceAdded,
  ]);

  //10.effect
  useEffect(() => {
    isValidParameterComing();
  }, [finalTileObject["Error"]]);

  // Helper to calculate and persist ticket counts (active/closed/total)
  const updateTicketCounts = (tickets: any[]) => {
    if (!Array.isArray(tickets) || tickets.length === 0) {
      sessionStorage.setItem("activeCount", "0");
      sessionStorage.setItem("closedCount", "0");
      sessionStorage.setItem("totalCount", "0");
      setActiveTicketCount(0);
      setRefreshHeaderTabCount(prev => !prev);
      return;
    }

    let closedCount = 0;
    let activeCount = 0;

    tickets.forEach((e: any) => {
      // Support both transformed tickets (targetSystem/status) and raw COSMIC tickets (source/statecode/statuscode)
      const rawSource = e?.source?.toString().toUpperCase() || '';
      const lowerCaseTargetSystem = e?.targetSystem?.toLowerCase() || (rawSource === 'GSOC' ? 'gsoc' : (rawSource || e?.statecode || e?.statuscode ? 'cosmic' : ''));
      // Normalize raw CRM status: statecode 1="resolved", 2="cancelled"; use || so numeric 0 falls through
      const rawStatusVal = e?.status?.toLowerCase() || (e?.statecode || e?.statuscode || '').toString().toLowerCase().trim();
      const lowerCaseStatus = rawStatusVal === '1' ? 'resolved' : rawStatusVal === '2' ? 'cancelled' : rawStatusVal;

      if (
        lowerCaseStatus === "closed" ||
        (lowerCaseTargetSystem === "hrd365" && lowerCaseStatus === "resolved") ||
        (lowerCaseTargetSystem === "uatracker" && lowerCaseStatus === "done") ||
        (lowerCaseTargetSystem === "cosmic" && (lowerCaseStatus === "closed" || lowerCaseStatus === "resolved" || lowerCaseStatus === "cancelled")) ||
        (lowerCaseTargetSystem === "gsoc" && (lowerCaseStatus === "closed" || lowerCaseStatus === "resolved" || lowerCaseStatus === "cancelled"))
      ) {
        closedCount++;
      } else {
        activeCount++;
      }
    });

    const totalCount = tickets.length;

    // Persist counts for header/tab display
    sessionStorage.setItem("activeCount", activeCount.toString());
    sessionStorage.setItem("closedCount", closedCount.toString());
    sessionStorage.setItem("totalCount", totalCount.toString());

    setActiveTicketCount(activeCount);
    setRefreshHeaderTabCount(prev => !prev);
  };

  // Load ticket data for MyTickets tab
  const loadTicketData = async () => {
    if (!isUserLoggedIn || !currentUserData) {
      return;
    }

    if (ticketDataLoaded) {
      return;
    }

    // Check session storage first (following app pattern used by MyContextProvider / Workspace)
    const workspaceKey = `myContextData_workspace_${currentUserDbId}`;
    const tileKey = `myContextData_tile_${currentUserDbId}`;

    const cachedTickets =
      sessionStorage.getItem(workspaceKey) ||
      sessionStorage.getItem(tileKey);
    
    if (cachedTickets) {
      try {
        const parsedTickets = JSON.parse(cachedTickets);
        
        // Handle both direct array and object with data property
        let ticketArray = null;
        if (Array.isArray(parsedTickets)) {
          ticketArray = parsedTickets;
        } else if (parsedTickets?.data && Array.isArray(parsedTickets.data)) {
          ticketArray = parsedTickets.data;
        }
        
        if (ticketArray && Array.isArray(ticketArray) && ticketArray.length > 0) {
          // Normalize back into workspace key for consistency
          sessionStorage.setItem(workspaceKey, JSON.stringify(ticketArray));

          // Update Redux and ticket counts so header can show My Tickets count
          reduxDispatch(setTicketDetailsData(ticketArray));
          updateTicketCounts(ticketArray);
          setTicketDataLoaded(true);
          return;
        } else {
          sessionStorage.removeItem(workspaceKey);
        }
      } catch (error) {
        sessionStorage.removeItem(workspaceKey);
      }
    }

    // No valid cached data found - fetch fresh data from APIs
    try {
      const userEmail = currentUserData?.email;
      const isCosmicEnabled = isFeatureEnabled('IsCosmicTicketsEnable');
      
      // Prepare API calls array
      const apiCalls = [
        getConsumptionAPI('/api/Support/GetIRISSupportRequests', context.authClient),
        getConsumptionAPI('/api/Support/GetUATSupportRequests', context.authClient),
        (userEmail && isCosmicEnabled) ? 
          getExternalConsumptionAPI(`api/Cosmic/my-tickets?email=${encodeURIComponent(userEmail)}`, context.authClient) :
          Promise.resolve(null),
        // Fetch ICM/HRD365 tickets from Cosmos DB (RAIN, NaaS, and other migrated forms)
        getExternalConsumptionAPI('api/McapsHelpBotTicket/MyTickets', context.authClient)
      ];

      // Fetch all APIs concurrently
      const results = await callMultipleAPIsSettled(apiCalls);
      let allTickets = [];

      // Process IRIS response (index 0) - mimic Workspace ticket structure
      if (results[0].status === 'fulfilled' && results[0].value?.data?.content?.value) {
        const irisRaw = results[0].value.data.content.value;
        const irisData = Array.isArray(irisRaw) ? irisRaw : [];
        allTickets = [...allTickets, ...irisData];
      }

      // Process UAT response (index 1) - mimic Workspace ticket structure
      if (results[1].status === 'fulfilled' && results[1].value?.data?.content?.value) {
        const uatRaw = results[1].value.data.content.value;
        const uatData = Array.isArray(uatRaw) ? uatRaw : [];
        allTickets = [...allTickets, ...uatData];
      }

      // Process COSMIC response (index 2)
      if (isCosmicEnabled && results[2] && results[2].status === 'fulfilled' && results[2].value) {
        const cosmicSource = results[2].value;
        const rawCosmic = cosmicSource.data || cosmicSource;
        const cosmicRawArray = Array.isArray(rawCosmic)
          ? rawCosmic
          : (Array.isArray(rawCosmic?.content?.value) ? rawCosmic.content.value : []);
        const cosmicData = (Array.isArray(cosmicRawArray) ? cosmicRawArray : []).map((ticket: any) => {
          const rawStatus = (ticket.status || ticket.statecode || ticket.statuscode || '').toString().toLowerCase().trim();
          let normalizedStatus = 'Active';
          if (rawStatus === 'resolved' || rawStatus === 'cancelled' || rawStatus === '1') {
            normalizedStatus = 'Resolved';
          } else if (rawStatus === 'closed' || rawStatus === '2') {
            normalizedStatus = 'Closed';
          } else if (rawStatus === 'active' || rawStatus === 'new' || rawStatus === '0') {
            normalizedStatus = 'Active';
          }
          const isGsoc = ticket.source?.toString().toUpperCase() === 'GSOC';
          return {
            ...ticket,
            ticketNumber: ticket.ticketnumber || ticket.ticketNumber || ticket.incidentid,
            status: normalizedStatus,
            targetSystem: isGsoc ? 'GSOC' : 'COSMIC',
          };
        });
        allTickets = [...allTickets, ...cosmicData];
      }

      // Process Cosmos DB response (index 3) - ICM/HRD365 tickets (RAIN, NaaS, migrated forms)
      try {
      if (results[3] && results[3].status === 'fulfilled' && results[3].value) {
        const cosmosSource = results[3].value;
        const cosmosRaw = cosmosSource.data || cosmosSource;
        const cosmosTickets = cosmosRaw?.tickets || [];
        const cosmosData = (Array.isArray(cosmosTickets) ? cosmosTickets : [])
          .filter((ticket: any) => {
            if (!ticket) return false;
            // Exclude failed/error tickets from MyTickets display
            const rawStatus = (ticket.status || '').toString().toLowerCase().trim();
            return rawStatus !== 'error' && rawStatus !== 'failed';
          })
          .map((ticket: any) => {
          const rawStatus = (ticket.status || '').toString().toLowerCase().trim();
          let normalizedStatus = 'Active';
          if (rawStatus === 'resolved' || rawStatus === 'closed') {
            normalizedStatus = 'Resolved';
          } else if (rawStatus === 'created' || rawStatus === 'in_progress' || rawStatus === 'success') {
            normalizedStatus = 'Active';
          }

          // Build ticket link based on platform
          let ticketLink = '';
          const platform = (ticket.platform || '').toUpperCase();
          if (platform === 'ICM' && ticket.ticketNumber) {
            ticketLink = `https://icm.ad.msft.net/imp/v5/incidents/details/${ticket.ticketNumber}/home`;
          } else if (platform === 'HRD365' && ticket.ticketNumber) {
            ticketLink = `https://aka.ms/askhr`;
          }

          // Extract title and description from requestPayload if available
          let title = '';
          let description = '';
          try {
            if (ticket.requestPayload) {
              const payload = typeof ticket.requestPayload === 'string' 
                ? JSON.parse(ticket.requestPayload) 
                : ticket.requestPayload;
              title = payload?.ShortDescription || payload?.shortDescription || payload?.ServiceName || payload?.serviceName || '';
              description = payload?.Description || payload?.description || '';
              
              // For Phase2 forms, Description may be empty (built server-side).
              // Build from available metadata fields as fallback.
              if (!description && payload?.Metadata) {
                const meta = payload.Metadata;
                const parts = Object.entries(meta)
                  .filter(([key, val]) => val && typeof val === 'string' && key !== 'FormId' && key !== 'Phase2CustomMapping' && key !== 'TileName')
                  .map(([key, val]) => `[${key}]: ${val}`);
                if (parts.length > 0) {
                  description = parts.join('\n');
                }
              }
              if (!description && payload?.metadata) {
                const meta = payload.metadata;
                const parts = Object.entries(meta)
                  .filter(([key, val]) => val && typeof val === 'string' && key !== 'FormId' && key !== 'Phase2CustomMapping' && key !== 'TileName')
                  .map(([key, val]) => `[${key}]: ${val}`);
                if (parts.length > 0) {
                  description = parts.join('\n');
                }
              }
            }
          } catch { /* ignore parse errors */ }

          return {
            ticketNumber: ticket.ticketNumber || ticket.ticketId,
            title: title || `${platform} Ticket`,
            input: description,
            status: normalizedStatus,
            createdDate: ticket.createdAt,
            targetSystem: platform,
            ticketLink: ticketLink,
          };
        });
        allTickets = [...allTickets, ...cosmosData];
      }
      } catch (cosmosError) {
        console.error("Error processing Cosmos DB tickets (non-blocking):", cosmosError);
      }

      // Ensure allTickets is always an array before storing/dispatching
      const validatedTickets = Array.isArray(allTickets) ? allTickets : [];

      // Update session storage with ticket data (following app pattern) - ALWAYS as array
      sessionStorage.setItem(workspaceKey, JSON.stringify(validatedTickets));
      
      // Update Redux store with ticket data and counts for header
      reduxDispatch(setTicketDetailsData(validatedTickets));
      updateTicketCounts(validatedTickets);
      setTicketDataLoaded(true);
      
    } catch (error) {
      console.error("Error loading ticket data:", error);
      setTicketDataLoaded(false);
    }
  };

  //12.effect - Handle URL-based tab selection
  useEffect(() => {
    const raw = location.pathname || "";
    const normalized = raw.replace(/\/+$/, "").toLowerCase(); // remove trailing slashes and lowercase
    const segments = normalized.split("/");
    const lastSegment = segments[segments.length - 1];

    if (lastSegment === "myvoice") {
      setselectedActiveTab("3");
    } else if (lastSegment === "mytickets") {
      setselectedActiveTab("2");
      
      // Load tickets immediately when routing to MyTickets (same as manual tab click)
      if (isUserLoggedIn && currentUserData && context && !ticketDataLoaded) {
        loadTicketData();
      }
    } 
  }, [location.pathname, isUserLoggedIn, currentUserData, context, ticketDataLoaded]);

  //13.effect - Load ticket data when MyTickets tab is selected
  useEffect(() => {
    if (selectedActiveTab === "2" && isUserLoggedIn && currentUserData && context && !ticketDataLoaded) {
      loadTicketData();
    }
  }, [selectedActiveTab, isUserLoggedIn, currentUserData, context, ticketDataLoaded]);

  //14.effect - Check early adopter status when user and announcements are loaded
  useEffect(() => {
    const checkAndShowAnnouncement = async () => {
      // Only check once when we have both user email and filtered announcements
      if (!hasCheckedEarlyAdopter.current && 
          filteredAnnouncementss && 
          filteredAnnouncementss.length > 0 && 
          currentUser.email) {
        hasCheckedEarlyAdopter.current = true;
        const isEarlyAdopter = await checkIsEarlyAdopter(currentUser.email);
        
        if (isEarlyAdopter) {
          setUserEmailCalled(true);
          setHideDialog(false);
        } else {
          setUserEmailCalled(true);
          setHideDialog(true);
        }
      }
    };
    checkAndShowAnnouncement();
  }, [currentUser.email, filteredAnnouncementss]);

  const fetchCatalogTileServices = async () => {
    try {
      const ONE_HOUR = 60 * 60 * 1000; // in milliseconds
      const storageKey = "securedTileNames";
      const storageTimestampKey = "securedTileNames_timestamp";

      const existingTiles = localStorage.getItem(storageKey);
      const storedTime = localStorage.getItem(storageTimestampKey);
      const now = new Date().getTime();
      const isExpired = !storedTime || now - parseInt(storedTime, 10) > ONE_HOUR;

      const needsCatalogCache = !sessionStorage.getItem("v2_services");
      if (context && (!existingTiles || isExpired || needsCatalogCache)) {
        const headers = await getHeaderTokenFunc(
          context.authClient,
          getAccessTokenForAPICall?.token
        );

        const response = await apiService(
          `${apiEndPoint}/api/V2_Service/GetAllServices`,
          "POST",
          {
            AreaFilter: null,
            mcemFilter: null,
            orgSummaryFilter: null,
          },
          headers?.request?.headers
        );

        const securedTileNames = response?.data
          ?.filter(tile => tile.isSecuredByAzureADGroup === true)
          .map(tile => tile.tileName);

        localStorage.setItem(storageKey, JSON.stringify(securedTileNames));
        localStorage.setItem(storageTimestampKey, now.toString());
        // Cache full catalog data for P-URL catalog fallback (tile not pinned in workspace)
        if (response?.data) {
          sessionStorage.setItem("v2_services", JSON.stringify(response.data));
        }
        setTriggerErrorMessage(!triggerErrorMessage);
      }
    } catch (error) {
      console.error("An error occurred while fetching Catalog Tiles Count.", error);
    }
  };
  useEffect(() => {
    if (finalTileObject.Error === SERVICE_LOCKED) return;
 
    if (finalTileObject.TileName) {
      let securedTilesData = JSON.parse(localStorage.getItem("securedTileNames") || "[]");
 
      if (securedTilesData.length === 0) {
        let services = sessionStorage.getItem("v2_services") || "[]";
        const tiles = JSON.parse(services);
        securedTilesData = tiles?.data
          ?.filter(tile => tile.isSecuredByAzureADGroup === true)
          .map(tile => tile.name);
      }
      const isTileSecure = securedTilesData?.includes(finalTileObject.TileName);
 
      if (isTileSecure) {
        // IMPORTANT: Only show SERVICE_LOCKED if user does NOT have MCAPS Copilot enabled.
        // For locked tiles accessed via PURL:
        // - If user has IsMCAPSCopilotEnabled = true → User has legitimate access, show copilot, NO error
        // - If user has IsMCAPSCopilotEnabled = false → User lacks access, show SERVICE_LOCKED error
        // This logic respects backend access validation (IsMCAPSCopilotEnabled flag from v2_users table).
       
        // Only block if user does NOT have MCAPS Copilot enabled
        if (!isMCAPSCopilotEnabled) {
          setFinalTileObject(prev => ({
            ...prev,
            Error: SERVICE_LOCKED,
          }));
        }
      }
    }
  }, [finalTileObject.Error, finalTileObject.TileName, triggerErrorMessage, isMCAPSCopilotEnabled]);

    // Log event when user visits using parameterized URL (similar to logUserPinClick from V2_Tile.tsx)
    const logParameterizedUrlVisit = (currentUrl: string, tileName: string, urlParams: URLSearchParams, currentUser: any) => {

        // Start Event Logging
        reduxDispatch(SETChileComponentName("Parameterized URL Visit"));
        reduxDispatch(SETHasServiceRequestTypeLogData(true));

        // Extract URL parameters for logging
        const irisUtterance = urlParams.get('IrisUtterance') || urlParams.get('irisutterance') || '';
        const area = urlParams.get('Area') || urlParams.get('area') || '';
        const segment = urlParams.get('Segment') || urlParams.get('segment') || '';
        const mode = urlParams.get('Mode') || urlParams.get('mode') || '';
        reduxDispatch(
            SETLogEventData({
                elementName: "Parameterized URL Access",
                elementId: "",
                action: "visit",
                message: `User accessed MCAPS Help via parameterized URL with TileName: ${tileName}, URL: ${currentUrl}`,
                profileSetting: `v2`,
                currentUrl: currentUrl,
                userEmail: currentUser?.email || 'Unknown',
                userOid: currentUser?.userObject?.localAccountId || 'Unknown',
            })
        );

        reduxDispatch(
            SETServiceRequestTypeLogData({
                ServiceName: tileName || "Unknown Service",
                RequestType: "",
                TileName: tileName || "",
                IsNonIrisService: irisUtterance ? "false" : "true",
                IrisUtterance: irisUtterance,
                UserArea: area,
                UserSegment: segment,
                Mode: mode,
                CurrentUrl: currentUrl,
                UserEmail: currentUser?.email || 'Unknown',
                UserOid: currentUser?.userObject?.localAccountId || 'Unknown',
                profileSetting: `v2`,
            })
        );
        reduxDispatch(SETIsCustomeLog(true));

        // Log incident PURL flyout event
        if (mode.toLowerCase() === 'incident') {
            reduxDispatch(
                SETLogEventData({
                    elementName: "Incident PURL - Flyout Opened",
                    elementId: "",
                    action: "incident_flyout_open",
                    message: `Incident PURL flyout shown for TileName: ${tileName}, IrisUtterance: ${irisUtterance || 'FAQ mode'}`,
                    profileSetting: `v2`,
                    currentUrl: currentUrl,
                    userEmail: currentUser?.email || 'Unknown',
                    userOid: currentUser?.userObject?.localAccountId || 'Unknown',
                })
            );
            reduxDispatch(SETIsCustomeLog(true));
        }
        // End Event Logging
    };

  


  //data for 3 useeffect
  const getConfig = async () => {

    if (!announcementJsondataa || !announcementJsondataa.Announcements || announcementJsondataa.Announcements.length === 0) {
      const jsonData = await dataService?.GetAnnouncements();
      SetAnnouncmentData(jsonData);
    }
    // Code to Hide The Whatsnew for Parmetrized URLS
    const urlParams = new URLSearchParams(window.location.search);
    // Check if either 'tileName' or 'tilename' exists (case-insensitive)
    if (Array.from(urlParams.keys()).some(key => key.toLowerCase() === 'tilename')) {
      // when the user visits the MCAPS Help using the Aks URL then firts we validate the user that the user exists in the DB
      // if a first-time user accesses the MCAPS Help portal via parameterized URL then create user API call gets triggred. 
      const res = await validateUserIDByEmailId();
      if (res?.status === 204) {
        await createUser();
        await getUserIDByEmailId();
        setUserEmailCalled(false);
      }
      // Log the parameterized URL visit event
      const tileName = urlParams.get('TileName') || urlParams.get('tilename') || urlParams.get('tileName') || 'Unknown Tile';
      logParameterizedUrlVisit(window.location.href, tileName, urlParams, currentUserData);
      // Capture any deep-link prompt intended for MCAPS Copilot and store it
      // so the header can open Copilot and pre-populate the input box.
      const appNameFromUrl = urlParams.get('appname') || urlParams.get('AppName') || '';
      const promptFromUrl = urlParams.get('prompt') || urlParams.get('Prompt') || '';
      // Check if tile name is ECIF from URL - set ECIF context for API calls
      const ecifTileName = process.env.REACT_APP_ECIF_TILE_NAME || "ECIF Support Services";
      const tileNameLower = tileName.toLowerCase();
      const isECIFFromUrl = tileNameLower === ecifTileName.toLowerCase() || tileNameLower.includes("ecif");
      // Check if tile name is SOS from URL - set SOS context for API calls
      const sosTileName = process.env.REACT_APP_SOS_TILE_NAME || "Unified Sales Operations Support (SOS)";
      const isSOSFromUrl = tileNameLower === sosTileName.toLowerCase() || tileNameLower.includes("sos") || tileNameLower.includes("unified sales operations");
      
      // Priority: explicit URL param > tile-name detection > none
      if (appNameFromUrl) {
        sessionStorage.setItem('mcapsCopilot_appName', appNameFromUrl);
      } else if (isECIFFromUrl) {
        sessionStorage.setItem('mcapsCopilot_appName', 'ECIF');
      } else if (isSOSFromUrl) {
        sessionStorage.setItem('mcapsCopilot_appName', 'SOS');
      }

      if (promptFromUrl) {
        try {
          // Persist minimal deep-link context; header will consume and clear it.
          const deepLinkContext = {
            tileName,
            appName: appNameFromUrl || (isECIFFromUrl ? 'ECIF' : (isSOSFromUrl ? 'SOS' : '')),
            prompt: promptFromUrl
          };
          sessionStorage.setItem('mcapsCopilot_deeplinkPrompt', promptFromUrl);
          sessionStorage.setItem('mcapsCopilot_deeplinkContext', JSON.stringify(deepLinkContext));
        } catch {
          // Non-fatal: if storage fails, we simply skip deep-link Copilot behavior
        }
      }
      setHideDialog(true);
      await fetchCatalogTileServices();
    } else {
        // For direct URL access (without tileName parameter), validate and create user if needed
      // This ensures first-time users are created in the DB even when accessing via direct URL
      const res = await validateUserIDByEmailId();
      if (res?.status === 204) {
        await createUser();
        await getUserIDByEmailId();
        setUserEmailCalled(false);
      }
    }
    if (!finalTileObject["isValidated"] && !isParamerterLoad) {
      const finalTile = GetTheTileConfiguration(finalTileObject, context);
      setFinalTileObject(await finalTile);
      setParamerterLoad("true");
    }
  };

  const getForm = async () => {
    let webFormNames: any[] = [];
    const storedWebFormNames = localStorage.getItem(
      WEBFORMNAMES_LOCAL_STORAGE_KEY
    );
    if (storedWebFormNames) {
      try {
        webFormNames = JSON.parse(storedWebFormNames);
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }

    if (webFormNames.length === 0) {
      // Fetch new data since it's not available in localStorage
      webFormNames = await getFormNames(context);
      // Store the result in localStorage with the versioned key
      if (webFormNames?.length > 0) {
        localStorage.setItem(
          WEBFORMNAMES_LOCAL_STORAGE_KEY,
          JSON.stringify(webFormNames)
        );
      }
    }
  };


  // Helper function to extract and clarify the filter logic
  function getFilterValue(filterArray) {
    return Array.isArray(filterArray) && filterArray.length > 0 ? filterArray.toString() : null;
  }

  // Helper function to handle API response
  function handleCatalogServicesResponse(response, setCatalogServicesResponse, hasFetchedData) {
    if (response?.data) {
      setCatalogServicesResponse(response);
      sessionStorage.setItem("v2_services", JSON.stringify(response.data));
      hasFetchedData.current = true;
    } else {
      throw new Error("Failed to fetch data.");
    }
  }

  // Refactored fetchDataAndUpdateState and extracted the filter logic into a separate function for sonar issue fix
  //data for 6 & 7 useeffect
  const fetchDataAndUpdateState = async () => {
    try {
      if (!context) return;

      const requestId = ++latestRequestId.current;
      let data = {
        AreaFilter: getFilterValue(SelectedCategoriesData["Areas"]),
        mcemFilter: getFilterValue(SelectedCategoriesData["mcemStage"]),
        categoryFilter: getFilterValue(SelectedCategoriesData["Category"]),
        orgSummaryFilter: getFilterValue(SelectedCategoriesData["orgSummaryOptions"]),
      };
      const headers: any = await getHeaderTokenFunc(
        context.authClient,
        getAccessTokenForAPICall.token
      );
      const response = await apiService(
        `${apiEndPoint}/api/V2_Service/GetAllServices`,
        "POST",
        data,
        headers.request.headers
      );

      if (requestId !== latestRequestId.current) {
        return;
      }

      handleCatalogServicesResponse(response, setCatalogServicesResponse, hasFetchedData);

    } catch (error) { }
  };

  const convertFiltersOptionsResponse = (filtersData) => {
    if (!filtersData) return {};

    const areaFilter = filtersData.Areas?.map(area => area.ID).join(",") || "";

    const mcemFilter = filtersData.statefilterOptions?.find(filter => filter.key === "mcemStage")
      ?.options.map(option => option.ID).join(",") || "";

    const orgSummaryFilter = filtersData.orgSummaryOptions?.map(org => org.ID).join(",") || "";

    return {
      AreaFilter: areaFilter,
      mcemFilter: mcemFilter,
      orgSummaryFilter: orgSummaryFilter
    };
  };

  const fetchCatalogTileCount = async () => {
    try {
      // Exit early if "Catalog_Tile_Count" exists in sessionStorage or context is not available
      if (sessionStorage.getItem("Catalog_Tile_Count") || !context) return;

      const allFilterOptions = await fetchAllFiltersOptions(context);
      const data = convertFiltersOptionsResponse(allFilterOptions);

      const headers = await getHeaderTokenFunc(
        context.authClient,
        getAccessTokenForAPICall.token
      );

      const response = await apiService(
        `${apiEndPoint}/api/V2_Service/GetAllServices`,
        "POST",
        data,
        headers?.request?.headers
      );
      sessionStorage.setItem("Catalog_Tile_Count", (response?.data?.length || 0).toString());
    } catch (error) {
      console.error("An error occurred while fetching Catalog Tiles Count.", error);
    }
  };

  const RequestAccessValidatorFunc = async () => {
    if (isUserLoggedIn && !isUserAuthorized) {
      try {
        if (context?.telemetryClient) {
          const response = await getGraphTransitiveMemberOf(context.authClient);
          if (response?.status === 200) {
            setUserAuthorized(response.data.value?.length > 0);
          }
        }
      } catch (error) { }
    }
  };
  const RequestAccessValidatorForAi = async () => {
    if (isUserLoggedIn && !isUserAuthorizedAi) {
      try {
        if (context?.telemetryClient) {
          let EnvVariables = getEnvVarUtils();
          const group = EnvVariables.find(
            (item) => item.key === "REACT_APP_AI_GROUP"
          )?.value;
          const response = await getGraphTransitiveMemberOfAi(
            context.authClient,
            group
          );
          if (response?.status === 200) {
            setUserAuthorizedAi(response.data.value?.length > 0);
          }
        }
      } catch (error) { }
    }
  };


  //data for 10useeffect
  const isValidParameterComing = () => {
    if (
      finalTileObject["Error"] !== undefined &&
      finalTileObject["Error"] !== ""
    ) {
      setShowErrorModal({
        isErrorModalVisible: true,
        errorMessage: finalTileObject["Error"],
      });
    }
  };

  //header code
  const handleFabricVisibilityChange = (isVisible: boolean) => {
    setShowFabricComponent(isVisible);
  };

  const getDisplayLocales = () => {
    let result = [];
    if (!appConfig.languageConfig.active) {
      return result;
    }
    const locales = appConfig.languageConfig.locales;
    Object.keys(locales).forEach(function (key, idx) {
      result.push({
        key: key,
        text: locales[key],
      });
    });
    return result;
  };

  const handleLocaleChange = (locale) => {
    reduxDispatch(setCurrentLocale(locale));
  };

  const handleChatBotIconClick = async () => {
    setIrisBotIconClicked(true);
    setIris_Utterance("");
    setTile_Name("");
    if (selectedActiveTab === "0") {
      setTimeout(() => {
        const panel = document.querySelector("#headerTab");

        if (panel !== null) {
          let ele = panel.parentNode.parentNode.parentNode as HTMLElement;
          ele.style.zIndex = "200000000";
        } else {
          const iris = document.querySelector("#irisMenu");

          if (iris !== null) {
            let ele = iris.parentNode.parentNode.parentNode.parentNode
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode as HTMLElement;
            ele.style.zIndex = "-1";
          }
        }
      }, 3000);
    }
  };

  const renderAppHeader = () => {
    return (
      <ShellHeader
        showFabricComponent={showFabricComponent}
        onFabricVisibilityChanged={handleFabricVisibilityChange}
        locales={getDisplayLocales()}
        dispatchUpdateLocaleAction={handleLocaleChange}
        isAppReady={currentAppState.isReady}
        theme={currentTheme}
        appName={appConfig.appName}
        isUserLoggedIn={isUserLoggedIn}
        user={currentUser}
        currentUserData={currentUserData}
        getUserIDByEmailId={getUserIDByEmailId}
        handleChatBotIconClick={handleChatBotIconClick}
        selectedActiveTab={selectedActiveTab}
        isIrisLoader={isIrisLoader}
        isPrompt={isPrompt}
        isFeedbackTab={selectedActiveTab === '3'}
        isMCAPSCopilotEnabled={isMCAPSCopilotEnabled}
      />
    );
  };

  const renderAppHeader_V2_Demo = () => {
    return (
      <ShellHeaderV2Demo
        showFabricComponent={showFabricComponent}
        onFabricVisibilityChanged={handleFabricVisibilityChange}
        locales={getDisplayLocales()}
        dispatchUpdateLocaleAction={handleLocaleChange}
        isAppReady={currentAppState.isReady}
        theme={currentTheme}
        appName={appConfig.appName}
        isUserLoggedIn={isUserLoggedIn}
        user={currentUser}
        currentUserData={currentUserData}
        getUserIDByEmailId={getUserIDByEmailId}
        handleChatBotIconClick={handleChatBotIconClick}
        selectedActiveTab={selectedActiveTab}
        isIrisLoader={isIrisLoader}
        isPrompt={isPrompt}
      />
    );
  };

  //welcome page
  const checkIsEarlyAdopter = async (upn: string): Promise<boolean> => {
    try {
      const response = await getConsumptionAPI(
        `/api/V2_User/IsEarlyAdopterOfAgent?upn=${upn}`,
        context.authClient
      );
      
      // Check if response is in data property (common pattern)
      const isEarlyAdopterValue = response?.data?.isEarlyAdopter ?? response?.isEarlyAdopter;
      
      if (isEarlyAdopterValue !== undefined) {
        return isEarlyAdopterValue;
      }
      return false;
    } catch (error) {
      console.error("Error checking early adopter status:", error);
      return false;
    }
  };

  const renderMultiPageWelcomeExp = () => {
    if (
      !finalTileObject["isValidated"] &&
      currentUserDbId === 0 &&
      context.authClient["account"] != null &&
      !isParamerterLoad
    ) {
      setParamerterLoad("true");
      GetTheTileConfiguration(finalTileObject, context);
    }
    return (
      <V2_WhatsNew
        filteredAnnouncements={
          filteredAnnouncementss !== null ? filteredAnnouncementss : []
        }
        hideDialog={hideDialog}
        toggleHideDialog={toggleHideDialog}
        openedThroughMenu={openedThroughMenu}
        title={
          !!filteredAnnouncementss?.length ? announcementJsondataa.title : ""
        }
        subText={
          !!filteredAnnouncementss?.length ? announcementJsondataa.subTitle : ""
        }
        currentUserData={currentUserData}
        currentUserDbId={currentUserDbId}
        currentUserIsWelcomeMessage={currentUserIsWelcomeMessage}
        handleChildStateChange={handleChildStateChange}
        currentUser={currentUser}
        setUserWelcomeUpdated={setUserWelcomeUpdated}
      />
    );
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const closeCopilot = () => {
    // setIsCopilotOpen(false);
    reduxDispatch(SetIsWwicCopilot(false));
    reduxDispatch(SetIsConversationId(false));
    reduxDispatch(SetInitialzeApp(false));
  };

  const setActiveTabKeyinShell = (activePivotKey) => {
    setIsPageLoad(false);
    const activetabkey = activePivotKey;
    if (activetabkey === "0") {
      setIsIrisLoader(false);
    }
    setselectedActiveTab(activePivotKey);
    // The below code is for scenario: On click on the catalog page and again going back to "My Help Workspace" page the iris copilot should be set up to the general index.
    (activePivotKey == 1 || activePivotKey == 3) && setTile_Name(""); // Update for catalog (1), tickets (2), and feedback (3) tabs
    sessionStorage.setItem("activeTabKey", activetabkey);
  };

  const resetShellIrisContext = () => {
    setIris_Utterance(null);
    set_irisAppName(null);
  };

  const handleIrisLoading = async (loader) => {
    setIsIrisLoader(loader);
  };

  function shouldShowSignin() {
    return !isUserLoggedIn && context && !loadedVisibility;
  }

  function shouldShowBusyIndicator() {
    return appConfig.enableUserSettingsApi && userProfileLoadingStatus;
  }

  function shouldShowExtensionBusyIndicator() {
    return appConfig.registrationConfig.active && extensionsLoadingStatus;
  }

  function shouldShowCopilot() {
    return (isWwicCopilotOpen || window.location.pathname === '/wwicai') &&
      isAiUser === true && isAiServicesEnabled === true && isWwicAiEnabled === true;
  }

  function shouldShowNotAiAuthorized() {
    return window.location.pathname === '/wwicai' &&
      (isAiUser === false || isAiServicesEnabled === false || isWwicAiEnabled === false);
  }

  const renderRoutes = () => {
    return (
      <ShellRoutes
        isUserLoggedIn={isUserLoggedIn}
        isStartupError={isStartupError}
        startupError={startupError}
        shouldShowSignin={shouldShowSignin}
        shouldShowBusyIndicator={shouldShowBusyIndicator}
        shouldShowExtensionBusyIndicator={shouldShowExtensionBusyIndicator}
        shouldShowCopilot={shouldShowCopilot}
        shouldShowNotAiAuthorized={shouldShowNotAiAuthorized}
        intl={intl}
        currentUserDbId={currentUserDbId}
        currentUserData={currentUserData}
        currentUser={currentUser}
        isProfileLoading={isProfileLoading}
        setProfileLoading={setProfileLoading}
        isPresetModal={isPresetModal}
        handleConfirmPreset={handleConfirmPreset}
        hideConfirmModel={hideConfirmModel}
        isWwicCopilotOpen={isWwicCopilotOpen}
        selectedActiveTab={selectedActiveTab}
        setActiveTabKeyinShell={setActiveTabKeyinShell}
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        setIris_Utterance={setIris_Utterance}
        resetShellIrisContext={resetShellIrisContext}
        setTile_Name={setTile_Name}
        set_irisAppName={set_irisAppName}
        setFormDataToIris={setFormDataToIris}
        setshowBotinShell={setshowBotinShell}
        setChatBotClicked={setChatBotClicked}
        setIrisBotIconClicked={setIrisBotIconClicked}
        handleIrisLoading={handleIrisLoading}
        messageHistory={messageHistory}
        irisPayload={irisPayload}
        closeCopilot={closeCopilot}
        setAddServiceId={setAddServiceId}
        catalogServicesResponse={catalogServicesResponse}
        setServicesAdded={setServicesAdded}
        isLoading={isLoading}
        setSearchTerm={setSearchTerm}
        setSingleServiceAdded={setSingleServiceAdded}
        hasFetchedData={hasFetchedData}
        addServiceId={addServiceId}
        setServiceDeleted={setServiceDeleted}
        isPageLoad={isPageLoad}
        userDataChanged={userDataChanged}
        finalTileObject={finalTileObject}
        isCanceledPreset={isCanceledPreset}
        reccomendedData={reccomendedData}
        recommendationLoaded={recommendationLoaded}
        setRecommendationLoaded={setRecommendationLoaded}
        setSubSegment={setSubSegment}
        setSegment={setSegment}
        userWelcomeUpdated={userWelcomeUpdated}
        refreshHeaderTabCount={refreshHeaderTabCount}
        setRefreshHeaderTabCount={setRefreshHeaderTabCount}
        isAiUser={isAiUser}
        isAiServicesEnabled={isAiServicesEnabled}
        isWwicAiEnabled={isWwicAiEnabled}
        setActiveTicketCount={setActiveTicketCount}
        loadTicketData={loadTicketData}
        context={context}
        extensionsRegistrationClient={extensionsRegistrationClient}
        shellProps={props}
      />
    );
  };

  const renderRoutes_V2_Demo = () => {
    return (
      <ShellRoutesV2Demo
        isUserLoggedIn={isUserLoggedIn}
        isStartupError={isStartupError}
        startupError={startupError}
        currentUserDbId={currentUserDbId}
        currentUserData={currentUserData}
        isProfileLoading={isProfileLoading}
        setProfileLoading={setProfileLoading}
        selectedActiveTab={selectedActiveTab}
        setActiveTabKeyinShell={setActiveTabKeyinShell}
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        setIris_Utterance={setIris_Utterance}
        setTile_Name={setTile_Name}
        set_irisAppName={set_irisAppName}
        setshowBotinShell={setshowBotinShell}
        setChatBotClicked={setChatBotClicked}
        context={context}
        loadedVisibility={loadedVisibility}
        userProfileLoadingStatus={userProfileLoadingStatus}
        extensionsLoadingStatus={extensionsLoadingStatus}
        intl={intl}
        extensionsRegistrationClient={extensionsRegistrationClient}
        shellProps={props}
      />
    );
  };

  //footer - iris
  const renderAppFooter = () => {
    if (selectedActiveTab === "1" || selectedActiveTab === "3") {
      return null;
    }
    const isDataArray = currentUserData && typeof currentUserData === "object";

    if (currentUserDbId !== 0 && isUserAuthorized && isDataArray) {
      return (
        <AppFooter
          IsUserAuthorized={isUserAuthorized}
          ShowBot={showBotinShell}
          setShowBot={setshowBotinShell}
          resetShellIrisContext={resetShellIrisContext}
          setIrisAppName={irisAppName === null ? "" : irisAppName}
          irisUtterance={iriS_Utterance === null ? "" : iriS_Utterance}
          tileName={tileName === null ? "" : tileName}
          currentUserData={currentUserData}
          irisBotIconClicked={irisBotIconClicked}
          setIrisBotIconClicked={setIrisBotIconClicked}
          irisToken={getIrisToken}
          SearchTerm={searchTerm}
          formDataToIris={formDataToIris}
          chatBotClicked={chatBotClicked}
          setChatBotClicked={setChatBotClicked}
          finalTileObject={finalTileObject}
          SubSegment={SubSegment}
          Segment={Segment}
        />
      );
    }
    return null;
  };

  //footer main
  const renderAppFooterMain = () => {
    const isDataArray = currentUserData && typeof currentUserData === "object";
    if (currentUserDbId !== 0 && isUserAuthorized && isDataArray) {
      return (
        <FooterMain
          selectedActiveTab={selectedActiveTab}
          isPrompt={isPrompt}
        />
      );
    }
    return null;
  };

  //render main
  const handleHeaderButtonAccess = async () => {
    const logoId = "header-brand-logo-id";
    const logoElement = document.getElementById(logoId);

    if (appConfig.brandConfig.active && !logoElement) {
      const logoElements = document.querySelectorAll(
        `[aria-label^='${appConfig.appName}']`
      );
      if (logoElements.length > 0) {
        createLogoElement(logoElements[0]);
        logoElements.forEach((el) => {
          const wrapper = document.createElement("h1");
          // Create an <h1> element
          el.parentNode.insertBefore(wrapper, el);
          // Insert <h1> before el in the DOM
          wrapper.appendChild(el);
        });
      }
    }

    hideBrandImageIfNeeded();
    // Show/hide feedback button
    const showFeedback = shouldShowFeedback();
    toggleFeedbackButtonVisibility(showFeedback);

    updateAppLogoLinkStyle();
  };

  const createLogoElement = (parentElement) => {
    const image = document.createElement("img");
    image.id = "header-brand-logo-id";
    image.src = "/images/MCAPSHelp-SVG.svg";
    image.className = "header_logo";
    image.alt = intl.formatMessage(messages.headerLogoImageText);
    image.onclick = () => {
      window.location.href = window.location.origin;
    };
    parentElement.parentNode.insertBefore(image, parentElement);
  };

  const hideBrandImageIfNeeded = () => {
    if (
      isUserLoggedIn &&
      appConfig.brandConfig.active &&
      appConfig.brandConfig.loginScreenOnly
    ) {
      const brandImage: any = document.querySelector("#header-brand-logo-id");
      if (brandImage) brandImage.style.display = "none";
    }
  };

  const shouldShowFeedback = () => {
    return (
      currentAppState.isReady &&
      isUserLoggedIn &&
      appConfig.ocvFeedbackConfig.active
    );
  };

  const toggleFeedbackButtonVisibility = (showFeedback) => {
    const feedbackButton: any = document.querySelector(
      "#coher-header-ocv-button-id"
    );
    if (feedbackButton)
      feedbackButton.style.display = showFeedback ? "" : "none";
  };

  const updateAppLogoLinkStyle = () => {
    const appLogoLink: any = document.querySelector(
      `a[aria-label="${appConfig.appName}"]`
    );
    if (appLogoLink) {
      appLogoLink.style.color = "white !important";
    }
  };

  const renderMain = (): JSX.Element => {
    currentLocaleRef.current = currentLocale;
    isUserLoggedInRef.current = isUserLoggedIn;

    const newAppState = {
      ...currentAppState,
      user: currentUser,
      appConfig,
      locale: currentLocale,
      theme: currentTheme,
      isUserLoggedIn: isUserLoggedIn,
      isNavCollapsed: isNavCollapsed,
    };
    const contextValue: IApplicationContext = {
      extensionsRegistrationClient: extensionsRegistrationClient,
      appState: newAppState,
      userDashboardTiles: userDashboardTiles,
    };
    return (
      <ApplicationContext.Provider value={contextValue}>
        <>{renderApp()}</>
      </ApplicationContext.Provider>
    );
  };

  const getPrompts = async () => {
    try {
      if (context && context.telemetryClient) {
        setLoadingPrompt(true);
        const response = await getConsumptionAPI(
          `/api/UserWorkSpace/GetAiPrompt`,
          context.authClient
        );
        const lastselectedcategory = sessionStorage.getItem("FinalCategory");
        if (response.status === 200) {
          const promptOptions = response?.data.map((prompt) => ({
            key: prompt.key,
            text: prompt.key,
            value: prompt.value,
            category: prompt.category,
            isDefault: prompt.isDefault,
          }));
          setArr(promptOptions);
          const category = Array.from(
            new Set(response?.data.map((category) => category.category))
          ).map((category) => ({
            key: category,
            text: category,
            value: category,
          }));

          setCategory(category);
          const defaultCategory = promptOptions?.find(
            (item) => item.isDefault === 1
          );
          if (
            defaultCategory &&
            (lastselectedcategory === "" ||
              lastselectedcategory === null ||
              lastselectedcategory === undefined)
          ) {
            setSelectedCategory(defaultCategory.category); // Set default category
            // handleCategoryChange(null, { key: defaultCategory.category, text: defaultCategory.category }); // Load related keys
          } else {
            setSelectedCategory(lastselectedcategory);
          }
          setLoadingPrompt(false);
        }
      }
    } catch (error) {
      console.error("An error occurred while fetching data.", error);
    } finally {
      setLoadingPrompt(false);
    }
  };

  const PromptConfig = () => {
    useEffect(() => {
      setIsPrompt(true);
    }, []);
    return (
      <>
        {loadingPrompt && <ShimmerLoader count={5} />}
        {(!isAiUser || (!loadingPrompt && !isUserAuthorizedAi)) && (
          <Stack
            verticalAlign="center"
            styles={{ root: { alignItems: "center", marginTop: "20%" } }}>
            <Text
              styles={{
                root: {
                  fontSize: "x-large",
                  fontWeight: "bold",
                  textAlign: "center",
                },
              }}>
              {NOT_AI_Authorised}
            </Text>
            <Text
              styles={{
                root: {
                  fontSize: "x-large",
                  fontWeight: "bold",
                  textAlign: "center",
                },
              }}>
              {NOT_AI_AUTHORISED_TWO}
            </Text>
          </Stack>
        )}
        {!loadingPrompt && isUserAuthorizedAi && isAiUser && (
          <V2_Prompt
            Arr={Arr}
            loadingPrompt={loadingPrompt}
            getPrompts={getPrompts}
            setLoadingPrompt={setLoadingPrompt}
            Category={Category}
            selectedCategory={selectedCategory}
            Upn={currentUser.email}
            Area={Area}
          />
        )}
      </>
    );
  };

  const irisPayload = (data) => {
    setFormDataToIris((prev) =>
      prev !== data.setFormDataToIris ? data.setFormDataToIris : prev
    );
    setshowBotinShell((prev) =>
      prev !== data.setShowBot ? data.setShowBot : prev
    );
    setChatBotClicked((prev) =>
      prev !== data.setChatBotClicked ? data.setChatBotClicked : prev
    );
    setIris_Utterance((prev) =>
      prev !== data.setIrisUtterance ? data.setIrisUtterance : prev
    );
    set_irisAppName((prev) =>
      prev !== data.setIrisAppName ? data.setIrisAppName : prev
    );
    setTile_Name((prev) =>
      prev !== data.setTileName ? data.setTileName : prev
    );
    setMessageHistory((prev) =>
      prev !== data.messageData ? data.messageData : prev
    );
  };

  const CopilotConfig = () => {
    useEffect(() => {
      setIsCopilot(true);
    }, []);
    return (
      <>
        {
          isAiUser == true && isAiServicesEnabled == true ? (
            <FluentProvider theme={teamsLightTheme}>
              <Chat
                setFormDataToIris={setFormDataToIris}
                setShowBot={setshowBotinShell}
                setChatBotClicked={setChatBotClicked}
                setIrisUtterance={setIris_Utterance}
                setIrisAppName={set_irisAppName}
                setTileName={setTile_Name}
                setMessageData={messageHistory}
                setIrisPayload={irisPayload}
              />
            </FluentProvider>
          ) : (
            <FluentProvider theme={teamsLightTheme}>
              <Chat
                setFormDataToIris={setFormDataToIris}
                setShowBot={setshowBotinShell}
                setChatBotClicked={setChatBotClicked}
                setIrisUtterance={setIris_Utterance}
                setIrisAppName={set_irisAppName}
                setTileName={setTile_Name}
                setMessageData={messageHistory}
                setIrisPayload={irisPayload}
              />
            </FluentProvider>
          )
          // "You dont have the permission to view this Page"
        }
      </>
    );
  };

  const renderApp = (): JSX.Element => {
    handleHeaderButtonAccess();

    if (!isSasCalled && context.authClient["account"] != null) {
      getStorageSasToken();
      setSasCalled(true);
    }

    if (!envVariableCalled && context.authClient["account"] != null) {
      getEnvVariables();
      setEnvVarCalled(true);
    }

    return (
      <EventLoggingProviderFC parentContext={context}>
        <BrowserRouter>
          {
            location.pathname == "/V2Demo" && currentUserDbId > 0 ?
              <Route
                exact
                path="/V2Demo"
                render={(props) => (
                  <NewUI_Shell {...props} renderAppHeader={renderAppHeader_V2_Demo} renderAppFooterMain={renderAppFooterMain} renderRoutes_V2_Demo={renderRoutes_V2_Demo}
                    classes={classes} isPrompt={isPrompt} isCopilot={isCopilot}
                    renderAppFooter={renderAppFooter}
                  />
                )}
              />
              :
              <>
                {currentUserDbId > 0 && renderAppHeader()}
                {currentUserDbId > 0 && (
                  <div>
                    <Route
                      exact
                      path="/imageprocessing"
                      component={CopilotConfig}
                    />
                  </div>
                )}
                {isCheckedMessage === false &&
                  isSasLoaded &&
                  envVariableLoaded &&
                  !isPrompt &&
                  userEmailCalled &&
                  filteredAnnouncementss &&
                  renderMultiPageWelcomeExp()}
                {/* {openTheSegmentPopUp && !isPrrenderAppFooterompt && renderSegmentPopup()} */}

                <main id="main" className={classes.main} tabIndex={-1}>
                  {!isPrompt && !isCopilot && renderRoutes()}
                </main>
                {!isPrompt && renderAppFooter()}
                {renderAppFooterMain()}
              </>
          }
        </BrowserRouter>
        <div
          role="alert"
          id="announce"
          aria-live="polite"
          aria-relevant="additions text"></div>


      </EventLoggingProviderFC>
    );
  };

  return renderMain();
};

export const V2_Shell = withRouter(injectIntl(V2_ShellComponent));


// Generated by Copilot
// updated on: 2025-09-17 | 6 lines updated | [Manual] | Removed unused params after upgrading from React 18.1 to 18.3.1 | Time Taken 3 min
// updated on: 2025-09-30 | 15 line added | [Manual] | Added standardized comment for code tracking | Time Taken 10 min
// updated on: 2025-10-14 | 8 lines added/updated | Auto Generated | Added feedback360 route handling, FeedbackTabComponent integration, and FeedbackWrapper rendering support | Time Taken 4 min
// Generated by Copilot
// updated on: 2025-10-24 | 5 lines updated | [Auto Generated] | Made tab selection route case-insensitive and replaced direct '/feedback360' check with normalized regex for '/myvoice' path | Time Taken 2 min
// updated on: 2026-02-26 | 4 lines added | [Auto Generated] | Cache full catalog data in v2_services sessionStorage during P-URL flow for catalog fallback when tile is not pinned | Time Taken 5 min
// updated on: 2026-02-26 | 1 line added | [Auto Generated] | Bug fix: fetch catalog data when v2_services is missing from sessionStorage even if securedTileNames is cached in localStorage | Time Taken 5 min
// updated on: 2026-03-19 | 5 lines added | [Auto Generated] | Zero-deploy tile routing: added appNameFromUrl priority for deep-link P-URL routing, stores copilot appName in sessionStorage before panel opens | Time Taken 10 min